import React from 'react';
import { CheckIcon, GlobeIcon } from 'lucide-react';
import { CtaBlock } from '../CtaBlock';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
const highlights = ['6 Volumi Clinici', '5 Bonus Esclusivi', 'Framework Visivi', 'Checklist Cliniche', 'Protocolli Pratici', 'Accesso a Vita'];
export function FinalCta() {
  return <section className="w-full bg-navy-deep px-4 pb-10 pt-14 sm:px-6 sm:pb-12 sm:pt-20" data-id="element-158" data-mp="1eob9m4yvgdqn">
      <div className="mx-auto max-w-2xl" data-id="element-159" data-mp="1eqnx0xnefgb3">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-160" data-mp="1iqy46dmxgcrj">
          Il tuo prossimo caso ti aspetta
        </p>
        <h2 className="mt-3 text-center font-display text-[27px] font-bold leading-tight text-white sm:text-4xl" data-id="element-161" data-mp="14sgn2yrj1yil">
          Smetti di andare a tentativi.
          <span className="mt-1 block italic text-brand" data-id="element-162" data-mp="2z5g7d56urgw7">Inizia a pianificare con un sistema.</span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-white/70" data-id="element-163" data-mp="342ptaav19afa">
          Ogni caso richiede comunque delle decisioni. La domanda è se continuerai ad affrontarle con incertezza…
          oppure con un processo clinico strutturato a cui potrai tornare ogni volta.
        </p>

        <ul className="mt-7 grid grid-cols-2 gap-2" data-id="element-164" data-mp="b0n94178g3dv">
          {highlights.map(item => <li key={item} className="flex items-start gap-1.5 rounded-xl bg-white/[0.06] px-3 py-2.5 text-[12.5px] font-semibold leading-tight text-white/85 ring-1 ring-white/10" data-id="element-165" data-mp="70mx0n7lw49z">
              <CheckIcon className="mt-[1px] h-3.5 w-3.5 shrink-0 text-brand" aria-hidden="true" data-id="element-166" data-mp="3aiwpxbjcnqmf" />
              {item}
            </li>)}
        </ul>

        <div className="mt-8 rounded-3xl bg-white p-6 text-center sm:p-8" data-id="element-167" data-mp="3jggoudtqpatv">
          <p className="text-[12px] font-extrabold uppercase tracking-[0.16em] text-navy/50" data-id="element-168" data-mp="13pb0meikrozv">Oggi</p>
          <p className="mt-1.5 font-display text-[64px] font-bold leading-none text-navy sm:text-[76px]" data-id="element-169" data-mp="yrsoygd6avo6">€19</p>
          <p className="mt-3 text-[13px] font-medium text-navy/60" data-id="element-170" data-mp="3si7jl7wv7r7d">
            Pagamento una tantum · Accesso immediato · Garanzia di 7 giorni
          </p>

          <div className="mt-6" data-id="element-171" data-mp="5ej979csi5bn">
            <CtaBlock label="Sì — voglio pianificare con sicurezza" note="Accesso immediato al Sistema Maestro di Pianificazione con Allineatori™" data-id="element-172" data-mp="5fclsqyfjp1p" />
          </div>

          <div className="mt-6" data-id="element-173" data-mp="39tstcmudgh7m">
            <Countdown data-id="element-174" data-mp="39qesjj1cwg2a" />
          </div>

          <p className="mt-5 flex items-center justify-center gap-1.5 text-[12.5px] font-medium text-navy/60" data-id="element-175" data-mp="3dtl2p1rlare1">
            <GlobeIcon className="h-3.5 w-3.5 text-navy/40" aria-hidden="true" data-id="element-176" data-mp="3is4tpgl1itd9" />
            Cambio di valuta automatico: paghi nella tua valuta locale.
          </p>

          <div className="mt-5" data-id="element-177" data-mp="2q4ihxl1nsifb">
            <ScarcityBar data-id="element-178" data-mp="2q3h458t9dhtw" />
          </div>

          <p className="mt-5 text-[13.5px] font-semibold leading-relaxed text-navy/70" data-id="element-179" data-mp="2q2fnmoth434s">
            Non perdere il tuo accesso. La tua biblioteca completa per la pianificazione clinica è a un solo clic di
            distanza.
          </p>
        </div>
      </div>
    </section>;
}